import useVisible from '@src/hooks/useVisible';
const useSetTime = (v = false) => {
    const tmpResult = useVisible(v);
    return tmpResult;
};
export default useSetTime;
